
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['chartist', 'jquery'], function (chartist, jquery) {
            return (root.returnExportsGlobal = factory(chartist, jquery));
        });
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory(require('chartist'), require('jquery'));
    } else {
        root['Chartist.plugins.tooltip'] = factory(root.chartist, root.jquery);
    }
}(this, function (Chartist, $) {

    /**
     * This Chartist tooltip plugin is a modified version of
     * https://github.com/Globegitter/chartist-plugin-tooltip.
     *
     */
    'use strict';

    var defaultOptions = {
        valueTransform: Chartist.noop,
        seriesName: true // Show name of series in tooltip.
    };
    const moment = require('moment')
    Chartist.plugins = Chartist.plugins || {};

    Chartist.plugins.tooltip = function (options) {
        options = Chartist.extend({}, defaultOptions, options);
        //console.log('options',options);
        var graphExpand;
        return function tooltip(chart) {
            var tooltipSelector = '.ct-point';
            if (chart instanceof Chartist.Bar || chart.options.classNames.chart == "ct-chart-bar") {
                tooltipSelector = '.ct-bar';
            } else if (chart instanceof Chartist.Pie) {
                tooltipSelector = '[class^=ct-slice]';
            }

            var $chart = $(chart.container),
                $toolTip = $chart
                .append('<div class="ct-tooltip"></div>')
                .find('.ct-tooltip')
                .hide();
                
                
            $chart.on('mouseenter', tooltipSelector, function() {
                var $point;
                var yAxisUnit = $(this).closest('ba-card').find('.yAxis').text();
                var hiddenDeviceId = $(this).closest('ba-card').find('.hiddenDeviceId').text();
                graphExpand = $(this).closest('ba-card').find('.graphExpand').text();
                if(yAxisUnit.indexOf(' (') !== -1) {
                    yAxisUnit = yAxisUnit.split(' (');
                    yAxisUnit = "("+yAxisUnit[1];
                } else {
                    yAxisUnit = '';
                }
                hiddenDeviceId = hiddenDeviceId.split(',');
                if(tooltipSelector == ".ct-bar" || tooltipSelector == ".ct-point"){
                    $point = $(this);
                }
                var seriesName = $point.parent().attr('ct:series-name'); 
                var value = $point.attr('ct:value') || '0';
                var meta = $point.attr('ct:meta') || '';
                var xAxisVal = value.split(',');
                var tooltipText = '';
                if(options.charttype && options.charttype=='meteringChart'){
                    if (options.getToolTipText && typeof options.getToolTipText === 'function') {
                        tooltipText = options.getToolTipText(value,meta);
                    }
                }
                else{
                    tooltipText = '<div class="tooltipHeading">'+moment(parseInt(xAxisVal[0])).format('YYYY-MM-DD hh:mm A')+'</div>';
                    if (options.seriesName && seriesName) {
                        tooltipText += seriesName + '<br>';
                    }
                    if ($point.attr('ct:meta')) {
                        tooltipText += $point.attr('ct:meta') + '<br>';
                    }
                    var deviceHtml ='';
                    deviceHtml = ", Device:"+hiddenDeviceId[$point.parent().index()];
                    
                    tooltipText += "<div class='yAxisValue'>Value:"+xAxisVal[1] +" "+ yAxisUnit + deviceHtml+"</div>";
                    
                }
                
                $toolTip.html(tooltipText);
                $(".ct-tooltip").css({"position":"absolute","border":"1px solid #ccc","background":"#fff", "color":"#000","text-align":"center", "z-index":"1"});
                $toolTip.show();
            });

            $chart.on('mouseleave', tooltipSelector, function() {
                $toolTip.hide();
            });

            $chart.on('mousemove', function(event) {
                if(graphExpand == "true") {
                    $toolTip.css({
                        left: (event.offsetX || event.originalEvent.layerX) - $toolTip.width() / 2,
                        top: (event.offsetY || event.originalEvent.layerY) - $toolTip.height()
                    }); 
                } else {
                    $toolTip.css({
                        left: (event.offsetX || event.originalEvent.layerX) - $toolTip.width() / 2,
                        top: (event.offsetY || event.originalEvent.layerY) - $toolTip.height() + 25
                    });
                }
            });

        };

    };

    return Chartist.plugins.tooltip;

}));



//////////////////
// WEBPACK FOOTER
// ./src/app/pages/plugins/chartist-plugin-tooltip/chartist-plugin-tooltip.js
// module id = ./src/app/pages/plugins/chartist-plugin-tooltip/chartist-plugin-tooltip.js
// module chunks = main